import { documentTemplateService } from "@services/document-templates-service";
import { useMutation } from "react-query";

export const useDownloadDocumentTemplateFileMutation = () => {
  return useMutation(documentTemplateService.downloadFile);
};
